import React from 'react';
import "./Annunci.css";
import {Glob as G} from "../../libs/Glob.mjs";
import appLib from "../../libs/appLib.mjs";
import MyCarousel from "../../controls/MyCarousel/MyCarousel.mjs";

const Annunci = class extends React.Component {
	constructor(props) {
		super(props);
		const s = {};
		s.data =  appLib.dataCache('weekly');
		s.weekday = '*';
		this.state = s;
		this.uid = G.generateUid('Annunci');
		this.load = this.load.bind(this);
	}
	componentDidMount() {
		setTimeout( this.load )
	}
	async load() {
		if ( this.state.loaded ) return;
		this.setState({ data: await appLib.data('weekly'), loaded: true });
	}
	render() {
		if ( ! this.state.data ) return '';
		const l = (this.state.data||[]).filter( i => (! i.disabled && (i.weekday === this.state.weekday)));
		if ( l.length === 0 ) return '';
		return(
			<div className={"WeekDay Annuncio"} id={this.uid}>
				{ this.props.carousel ? (
					<MyCarousel items={ l.map(k => k.msg ) } />
				) : (
					l.map(( l, i ) => <div key={ i }><p>{ appLib.text(l.msg) }</p></div> )
				) }
			</div>
		);
	}
}

export default Annunci;
